// для массива темплейтов
import _ from 'lodash';

import { extractType } from '../reducers/analyticsApp';
import { EVENT_TEMPLATE_TYPE, RETENTION_TEMPLATE_TYPE } from '../constants/dashboards';
import { executeEventOptions } from '../reducers/event/execute';
import { getView, getViews } from '../utils/event/common';
import { getRange, timeUnits } from './eventConverter';

// составляет description и нескольких query темплейта.
const getQueriesDescription = (template) => {
  const descriptions = template.description.split(' + ');
  return template.type === RETENTION_TEMPLATE_TYPE
    ? { [template.retentionQuery.id]: descriptions[0] }
    : template.queries.reduce(
        (res, { id }, index) => ({
          ...res,
          [id]: descriptions[index],
        }),
        {}
      );
};

const convertFilter = (filter) =>
  Object.fromEntries(
    Object.entries(filter).map(([key, value]) => [
      key,
      value.map((clause) => ({
        conditions: _.get(clause, 'conditions', []),
        segmentConditions: _.get(clause, 'segmentConditions', []),
      })),
    ])
  );

const queryConverter = (item) => {
  const { query } = item;
  return {
    ...item,
    query: {
      eventName: query.eventName,
      aggregations: query.aggregations.map((aggregation) => ({
        type: aggregation.type,
        field: _.get(aggregation, 'field', null),
      })),
      groupBy: query.groupBy,
      filter: convertFilter(query.filter),
      globalFilter: query.globalFilter,
      timezone: query.timezone,
    },
  };
};

const getQueriesFromTemplate = (template) => {
  switch (template.type) {
    case EVENT_TEMPLATE_TYPE:
      return _.get(template, 'queries', []).map(queryConverter);
    case RETENTION_TEMPLATE_TYPE:
      return [template.retentionQuery];
    default:
      return template.queries;
  }
};

export const getTemplateInfo = (state) => {
  const filterExtractor = (event, field) => extractType(state, event, field);

  return { filterExtractor };
};

// для одного темплейта
export const convertTemplateResponse = (template, templateInfo) => {
  const { filterExtractor } = templateInfo;

  return {
    ...template,
    queriesDescription: getQueriesDescription(template),
    queries: getQueriesFromTemplate(template),
    filterExtractor,
  };
};

export const convertTemplatesResponse = (result, templateInfo) =>
  result.reduce(
    (res, template) => ({
      ...res,
      [template.id]: {
        ...template,
        ...convertTemplateResponse(template, templateInfo),
      },
    }),
    {}
  );

export const convertTemplateResult = (type, queries) =>
  type === EVENT_TEMPLATE_TYPE
    ? // если шаблон имеет type: event то результат может состоять из нескольких query
      // поэтому преобразование для этого типа к результату отличается.
      {
        ...queries[0].result,
        result: queries.flatMap(({ result }) => result.result).filter((result) => !!result),
      }
    : { ...queries[0].result };

// конвертирует темплейт в результат для отображения на графике и таблице.
export const eventTemplateToResult = (templateResult, template, timezone, range) => {
  return {
    result: templateResult.result,
    executeTime: new Date().valueOf(),
    timezone,
    options: {
      ...executeEventOptions,
      ...getRange(range.from, range.to, timezone, timeUnits[template.queries[0].query.groupBy[0]]),
      columnChartSorting: {
        ...executeEventOptions.columnChartSorting,
        axis: template.sortingAxis,
        order: template.sortingOrder,
      },
      // по умолчанию всегда включен single, для отображения на превью
      singleChartMode: true,
      showFormula: template.formula === null,
      calcTotal: template.showGrandTotal,
      averageLine: template.showAverage,
      medianLine: template.showMedian,
      enteredFormula: template.formula,
      showSortingOptions: true,
      view: getView(executeEventOptions.view, templateResult.result),
      views: getViews(templateResult.result),
    },
  };
};
